// extracted by mini-css-extract-plugin
module.exports = {"header":"MenuModal_header__mxWeT","nav":"MenuModal_nav__yBAKu","label":"MenuModal_label__YBf0O"};